import styled from "styled-components";

export const Button = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;

  background-color: ${({ theme: { colors } }) => colors.main.yellow};
  border: 1px solid rgba(23, 29, 43, 0.08);
  padding: 11px 26px;
  border-radius: ${({ theme: { radii } }) => radii.sm};

  color: ${({ theme: { colors } }) => colors.navy[800]};
  font-family: ${({ theme: { font } }) => font.heading};
  font-weight: 600;
  font-size: ${({ theme: { font } }) => font.main};
  letter-spacing: 0.01em;
  line-height: 1.2;
  white-space: nowrap;

  box-shadow: ${({ theme: { shadow } }) => shadow.xs};
  transition: background-color ${({ theme: { transition } }) => transition.fast},
    box-shadow ${({ theme: { transition } }) => transition.fast},
    transform ${({ theme: { transition } }) => transition.fast};

  cursor: pointer;

  &:hover {
    background-color: ${({ theme: { colors } }) => colors.yellowDeep};
    box-shadow: ${({ theme: { shadow } }) => shadow.sm};
    transform: translateY(-1px);
  }

  &:active {
    transform: translateY(0);
    box-shadow: ${({ theme: { shadow } }) => shadow.xs};
  }

  &:focus-visible {
    outline: none;
    box-shadow: ${({ theme: { shadow } }) => shadow.focus};
  }

  &:disabled {
    opacity: 0.55;
    cursor: not-allowed;
    transform: none;
    box-shadow: none;
  }
`;
